/* DARIA — smart fill
   يقرأ إطار 1 بكسل حول الصورة ويملأ الصندوق بلون واحد صلد.
   ينطبق على: كروت المنتجات · أقواس الأقسام · صفحة المنتج · سلايدر الهيرو · البانر التحريري */
(function () {
  var THRESH = 18;
  var OUTLIER = 0.04;
  var FALLBACK = '#F7F4F0';

  function strip(ctx, x, y, w, h, out) {
    var d = ctx.getImageData(x, y, w, h).data;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 200) continue;
      out.push([d[i], d[i + 1], d[i + 2]]);
    }
  }
  function dist(a, b) {
    return Math.sqrt((a[0]-b[0])*(a[0]-b[0]) + (a[1]-b[1])*(a[1]-b[1]) + (a[2]-b[2])*(a[2]-b[2]));
  }

  function analyse(el, src) {
    if (!src) { apply(el, FALLBACK); return; }
    var key = 'dfill3:' + src;
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) { apply(el, hit); return; }
    } catch (e) {}

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.onerror = function () { apply(el, FALLBACK); };
    img.onload = function () {
      var col = FALLBACK;
      try {
        var w = img.naturalWidth, h = img.naturalHeight;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.imageSmoothingEnabled = false;
        ctx.drawImage(img, 0, 0);

        var px = [];
        strip(ctx, 0, 0, w, 1, px);
        strip(ctx, 0, h - 1, w, 1, px);
        strip(ctx, 0, 0, 1, h, px);
        strip(ctx, w - 1, 0, 1, h, px);
        if (!px.length) throw 0;

        var mean = [0, 1, 2].map(function (i) {
          return px.reduce(function (s, p) { return s + p[i]; }, 0) / px.length;
        });
        var far = 0;
        for (var i = 0; i < px.length; i++) if (dist(px[i], mean) > THRESH) far++;

        if (far / px.length <= OUTLIER) {
          col = 'rgb(' + mean.map(function (v) { return Math.round(v); }).join(',') + ')';
        } else {
          var bins = {}, best = null, bestN = 0;
          for (var j = 0; j < px.length; j++) {
            var p = px[j];
            var k = (p[0] >> 4) + '-' + (p[1] >> 4) + '-' + (p[2] >> 4);
            var b = bins[k] || (bins[k] = { n: 0, s: [0, 0, 0] });
            b.n++; b.s[0] += p[0]; b.s[1] += p[1]; b.s[2] += p[2];
            if (b.n > bestN) { bestN = b.n; best = b; }
          }
          if (best && bestN / px.length >= 0.45) {
            col = 'rgb(' + best.s.map(function (v) { return Math.round(v / best.n); }).join(',') + ')';
          }
        }
      } catch (err) {}
      try { sessionStorage.setItem(key, col); } catch (e) {}
      apply(el, col);
    };
    img.src = src;
  }

  function apply(el, col) {
    el.style.setProperty('--d-fill', col);
    el.classList.add('is-filled');
  }

  function fromImg(el) {
    if (el.dataset.filled) return;
    var im = el.querySelector('img');
    if (!im) return;
    el.dataset.filled = '1';
    var src = el.getAttribute('data-fill') || im.currentSrc || im.src;
    if (im.complete || el.getAttribute('data-fill')) analyse(el, src);
    else im.addEventListener('load', function () { analyse(el, im.currentSrc || im.src); }, { once: true });
  }

  function run() {
    document.querySelectorAll('.d-card__media[data-fill]').forEach(function (el) {
      if (el.dataset.filled) return;
      el.dataset.filled = '1';
      analyse(el, el.getAttribute('data-fill'));
    });
    document.querySelectorAll('.d-arch__img').forEach(fromImg);
    document.querySelectorAll('.d-gallery__main').forEach(fromImg);
    document.querySelectorAll('.d-slide__media').forEach(fromImg);
    document.querySelectorAll('.d-editorial__img').forEach(fromImg);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run, { once: true });
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-more]') || ev.target.closest('[data-thumb]')) setTimeout(run, 60);
  });
})();
